import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";

import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import TitleInput from "../../components/molecules/input/titleInput";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import MainBtn from "../../components/atoms/button/mainBtn";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import MainBorderBtn from "../../components/atoms/button/mainBorderBtn";
import PretendardText from "../../components/atoms/text/pretendardText";
import { errorHandler } from "../../util/errorHandler";
import AuthApi from "../../api/auth.api";
import MemberApi from "../../api/member.api";

// 네이버로그인
const initNaver = new window.naver.LoginWithNaverId({
  clientId: "3sRX9KuAdGwkmqR8Oucu",
  // callbackUrl: `http://localhost:3000/finlive/login`,
  callbackUrl: `https://finlive.net/finlive/login`,
  isPopup: false,
  loginButton: { color: "green", type: 2, height: 40 },
});

const Login = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const navigate = useNavigate();

  const location = useLocation();
  const { path } = location.state || {};
  const [searchParams] = useSearchParams();

  const getSafeReturnPath = () => {
    const requestedPath = path || searchParams.get("returnUrl");
    if (!requestedPath) return null;

    try {
      const target = new URL(requestedPath, window.location.origin);
      if (
        target.origin !== window.location.origin ||
        !target.pathname.startsWith("/finlive/")
      ) {
        return null;
      }

      return `${target.pathname}${target.search}${target.hash}`;
    } catch (error) {
      return null;
    }
  };

  const moveAfterLogin = () => {
    navigate(getSafeReturnPath() || route.home, { replace: true });
  };

  const [id, setId] = useState("");
  const [idErrorM, setIdErrorM] = useState("");
  const [pw, setPw] = useState("");
  const [pwErrorM, setPwErrorM] = useState("");

  const handleLogin = async () => {
    try {
      let obj = { email: id, password: pw };
      const response = await AuthApi.login(obj);
      sessionStorage.setItem("token", response.data.data.accessToken);

      const myInfoRP = (await MemberApi.getMyInfo()).data.data.content;

      sessionStorage.setItem("joinType", "NORMAL");
      sessionStorage.setItem("isLogin", "true");
      sessionStorage.setItem("email", myInfoRP.email);
      sessionStorage.setItem("id", myInfoRP.id);
      sessionStorage.setItem("name", myInfoRP.name);
      sessionStorage.setItem("nickname", myInfoRP.nickname);
      sessionStorage.setItem("profile", myInfoRP.profileServerFileName);
      sessionStorage.setItem("membership", myInfoRP.membership);
      sessionStorage.setItem("phoneNumber", myInfoRP.phoneNumber);

      moveAfterLogin();
    } catch (error) {
      errorHandler(error);
    }
  };

  const initKakao = () => {
    const jsKey = "74afb3279d72de37054f04f1268a58a2";
    const Kakao = window.Kakao;
    if (Kakao && !Kakao.isInitialized()) {
      Kakao.init(jsKey);
    }
  };

  useEffect(() => {
    initKakao();
    initNaver.init();
  }, [isMobile]);

  useEffect(() => {
    if (initNaver.accessToken) {
      initNaver.getLoginStatus((status) => {
        if (status) {
          // Flutter로 메시지 전송

          let userDataTemp = JSON.parse(JSON.stringify(initNaver.user));

          const socialId = userDataTemp.id;

          const userData = {
            email: userDataTemp.email ? userDataTemp.email : "",
            name: userDataTemp.name ? userDataTemp.name : "",
            nickname: userDataTemp?.nickname ? userDataTemp?.nickname : "",
          };

          if (userDataTemp.mobile) {
            let temp = formatPhoneNumber(userDataTemp.mobile);
            userData.phone = temp;
          }

          handleSNSLogin(String(socialId), "NAVER", userData);
        }
      });
    }
  }, [initNaver]);

  const kakaoLogin = () => {
    window.Kakao.Auth.login({
      success() {
        window.Kakao.API.request({
          url: "/v2/user/me",
          success(res) {
            const socialId = res.id;
            const kakaoAccount = res.kakao_account;

            const userData = {
              email: kakaoAccount.email ? kakaoAccount.email : "",
              name: kakaoAccount.name ? kakaoAccount.name : "",
              nickname: kakaoAccount.profile?.nickname
                ? kakaoAccount.profile?.nickname
                : "",
            };

            if (kakaoAccount.phone_number) {
              let temp = formatPhoneNumber(kakaoAccount.phone_number);
              userData.phone = temp;
            }

            handleSNSLogin(String(socialId), "KAKAO", userData);
          },
          fail(error) {},
        });
      },
      fail(error) {},
    });
  };

  const formatPhoneNumber = (phoneNumber) => {
    // 1. 숫자 외 모든 문자 제거 (국가코드 포함)
    const cleanNumber = phoneNumber.replace(/[^\d]/g, "");

    // 2. 국가 코드 "+82" 제거 및 "010"으로 시작하게 변경
    const withoutCountryCode = cleanNumber.startsWith("82")
      ? "0" + cleanNumber.slice(2) // "82"를 "0"으로 대체
      : cleanNumber;

    return withoutCountryCode;
  };
  const naverLogin = () => {
    const naverLoginBtn = document.getElementById("naverIdLogin").firstChild;
    naverLoginBtn.click();
  };

  const handleSNSLogin = async (socialId, joinType, userData) => {
    try {
      let obj = { email: joinType, password: socialId };
      const response = await AuthApi.socialLogin(obj);
      sessionStorage.setItem("token", response.data.data.accessToken);

      const myInfoRP = (await MemberApi.getMyInfo()).data.data.content;
      sessionStorage.setItem("joinType", joinType);
      sessionStorage.setItem("isLogin", "true");
      sessionStorage.setItem("email", myInfoRP.email);
      sessionStorage.setItem("id", myInfoRP.id);
      sessionStorage.setItem("name", myInfoRP.name);
      sessionStorage.setItem("nickname", myInfoRP.nickname);
      sessionStorage.setItem("profile", myInfoRP.profileServerFileName);
      sessionStorage.setItem("membership", myInfoRP.membership);
      moveAfterLogin();
    } catch (error) {
      if (error?.response) {
        if (error?.response?.status === 400) {
          navigate(`${route.register}`, {
            state: {
              socialId: socialId,
              joinType: joinType,
              userData: userData,
            },
          });

          return;
        }
      }

      errorHandler(error);
    }
  };

  return (
    <>
      <LoginSection>
        <PCContainer
          style={{
            padding: isSmall ? "80px 20px 80px 20px" : "80px 0px 150px 0px",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: isMobile ? "100%" : 790,
              padding: isMobile
                ? "0px"
                : isTablet
                ? "60px 140px"
                : "60px 205px",
              boxShadow: isMobile ? "none" : "0px 0px 6px 0px #0000001A",
              borderRadius: isMobile ? 0 : 30,
            }}
          >
            <LSBdDisplay02
              style={{
                textAlign: "center",
                marginBottom: 32,
              }}
            >
              로그인
            </LSBdDisplay02>

            <TitleInput
              title={"아이디"}
              essential={true}
              placeholder={"아이디를 입력해 주세요."}
              type={"text"}
              onChange={(e) => {
                setId(e.target.value);
              }}
              value={id}
              warningMessage={idErrorM}
              style={{
                marginBottom: 20,
              }}
            />
            <TitleInput
              title={"비밀번호"}
              essential={true}
              placeholder={"비밀번호를 입력해 주세요."}
              type={"password"}
              onChange={(e) => {
                setPw(e.target.value);
              }}
              value={pw}
              warningMessage={pwErrorM}
              style={{
                marginBottom: isMobile ? 0 : 20,
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  if (pw && pwErrorM === "" && id && idErrorM === "") {
                    handleLogin();
                  }
                }
              }}
            />

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: isMobile ? "center" : "flex-end",
                alignItems: "center",
                marginTop: 28,
                marginBottom: 28,
              }}
            >
              <LSRgBody01
                onClick={() => {
                  navigate(route.id_find);
                }}
                style={{
                  color: "#6F7480",
                  cursor: "pointer",
                }}
              >
                아이디 찾기
              </LSRgBody01>
              <div
                style={{
                  marginLeft: 13,
                  marginRight: 13,
                  width: 1,
                  height: 12,
                  background: "#DBDDE0",
                }}
              />
              <LSRgBody01
                onClick={() => {
                  navigate(route.pw_find);
                }}
                style={{
                  color: "#6F7480",
                  cursor: "pointer",
                }}
              >
                비밀번호 찾기
              </LSRgBody01>
            </div>

            <MainBtn
              disabled={
                id && pw && idErrorM === "" && pwErrorM === "" ? false : true
              }
              onClick={() => {
                handleLogin();
              }}
              style={{
                marginBottom: 14,
              }}
            >
              <LSRgH1HeadLine
                style={{
                  color: "#FFFFFF",
                  textAlign: "center",
                }}
              >
                로그인
              </LSRgH1HeadLine>
            </MainBtn>

            <MainBorderBtn
              onClick={() => {
                navigate(route.register);
              }}
              style={{
                marginBottom: isMobile ? 30 : 64,
              }}
            >
              <LSRgH1HeadLine
                style={{
                  color: "#5050FF",
                  textAlign: "center",
                }}
              >
                회원가입
              </LSRgH1HeadLine>
            </MainBorderBtn>

            <div
              style={{
                marginBottom: 30,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: 1,
                  background: "#101113",
                }}
              />
              <PretendardText
                style={{
                  color: "#101113",
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: 500,
                  marginLeft: 20,
                  marginRight: 20,
                }}
              >
                간편로그인
              </PretendardText>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  background: "#101113",
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  kakaoLogin();
                }}
                style={{
                  width: 48,
                  height: 48,
                  cursor: "pointer",
                  marginRight: 30,
                }}
                src={"/assets/icons/kakao.png"}
                alt="kakao"
              />
              <div id="naverIdLogin" style={{ display: "none" }}></div>
              <img
                onClick={() => {
                  naverLogin();
                }}
                style={{
                  width: 48,
                  height: 48,
                  cursor: "pointer",
                }}
                src={"/assets/icons/naver.png"}
                alt="naver"
              />
            </div>
          </div>
        </PCContainer>
      </LoginSection>
    </>
  );
};

export default Login;

const LoginSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;
